import { CrewCheckBox } from 'components/devextreme/crewCheckBox'
import { FC, memo, useCallback } from 'react'
import { AnnouncementContextMenu } from '../anncounementContextMenu/announcementContextMenu'
import { useTranslation } from '@crew/modules/i18n'
import { AnnouncementContextMenuType } from 'enums/app'
import { useAppSelector } from 'states/hooks'
import { useAnnouncementService } from '@crew/states'

export const AnnouncementHeader: FC = memo(() => {
  const { t } = useTranslation()

  // 「未読のみ」フィルタのreduxに格納されている値
  const isUnreadFilterEnabled = useAppSelector(
    (state) => state.announcement.UnreadOnly
  )

  const announcementService = useAnnouncementService()

  const handleUnreadFilterChange = useCallback(
    (value: boolean | null) => {
      if (value === null) {
        // nullが入ってくることは考えにくいが、nullの場合は何もせず終了する
        return
      }

      // 「未読のみ」フィルタの状態を更新する
      announcementService.setUnreadOnly(value)
    },
    [announcementService]
  )

  return (
    <div className="flex flex-row p-2.5">
      <CrewCheckBox
        text={t('label.UnreadOnly')}
        value={isUnreadFilterEnabled}
        onValueChange={handleUnreadFilterChange}
      />

      <div className="ml-auto">
        <AnnouncementContextMenu
          announcementId={undefined}
          visible={true}
          contextMenuType={AnnouncementContextMenuType.ForAll}
          showBorder={false}
        />
      </div>
    </div>
  )
})
